// @flow strict
import { useRef } from 'react';

const uidLength = 32;
const uidCharacters = '0123456789ABCDEF';

/**
 * @return a random string that will keep the same value for the lifetime of the typeahead component
 */
const useSearchSessionId = (): string => {
  const searchSessionId = useRef('');

  if (searchSessionId.current === '') {
    const randomId = Array(uidLength)
      .fill(0)
      .map(() => uidCharacters[Math.floor(Math.random() * uidCharacters.length)])
      .join('');

    searchSessionId.current = `${randomId}${String(Date.now())}ssid`;
  }

  return searchSessionId.current;
};

export default useSearchSessionId;
